import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { AddIdentificationFields } from '../..';
import Section from 'ui/atoms/section';
import Date from 'ui/atoms/date';
import DocumentModal from 'src/libraries/document-modal';
import { snakeToCamelCaseWithNumbers } from 'ui/helper/case-transforms';
import Grid, { Col } from 'ui/atoms/grid';
import PlaceholderFallback from 'src/ui/atoms/placeholder-fallback';

export interface ConfirmIdentificationDocumentDataProps {
  identification: AddIdentificationFields;
}

const ConfirmIdentificationDocumentData: FunctionComponent<ConfirmIdentificationDocumentDataProps> = (props) => {
  const { identification } = props;

  return (
    <Section>
      <p>
        <strong>
          <Translate name="dashboardIssuerInvestorDetails.addIdentificationForm.subtitleIdentification" />
        </strong>
      </p>
      <Grid>
        <Col width={6} spacing="small">
          <Translate name="dashboardInvestorSettings.identification.legitimationProtocol" />
        </Col>
        <Col width={6} spacing="small">
          <Translate
            name="common.viewDocument"
            args={[
              (text: string, key) => {
                if (!identification?.legitimationProtocol?.file) return;
                return (
                  <DocumentModal key={key} file={URL.createObjectURL(identification?.legitimationProtocol?.file)}>
                    {text}
                  </DocumentModal>
                );
              },
            ]}
          />
        </Col>
      </Grid>
      <Grid>
        <Col width={6} spacing="small">
          <Translate name="dashboardInvestorSettings.identification.documentId" />
        </Col>
        <Col width={6} spacing="small">
          <PlaceholderFallback>{identification.documentId}</PlaceholderFallback>
        </Col>
      </Grid>
      <Grid>
        <Col width={6} spacing="small">
          <Translate name="dashboardInvestorSettings.identification.identificationDate" />
        </Col>
        <Col width={6} spacing="small">
          <Date>{identification.identificationDate}</Date>
        </Col>
      </Grid>
      <Grid>
        <Col width={6} spacing="small">
          <Translate name="dashboardInvestorSettings.identification.documentType" />
        </Col>
        <Col width={6} spacing="small">
          <Translate
            name={`identificationDocumentType.${snakeToCamelCaseWithNumbers(
              identification.documentType.toLowerCase(),
            )}`}
          />
        </Col>
      </Grid>
      <Grid>
        <Col width={6} spacing="small">
          <Translate name="dashboardInvestorSettings.identification.validationInterval" />
        </Col>
        <Col width={6} spacing="small">
          <>
            {identification.documentValidFrom && (
              <>
                <Date>{identification.documentValidFrom}</Date>-
              </>
            )}
            <Date>{identification.documentValidTo}</Date>
          </>
        </Col>
      </Grid>
      <Grid>
        <Col width={6} spacing="small">
          <Translate name="dashboardInvestorSettings.identification.issuingOffice" />
        </Col>
        <Col width={6} spacing="small">
          <PlaceholderFallback>{identification.issuingOffice}</PlaceholderFallback>
        </Col>
      </Grid>
    </Section>
  );
};

export default ConfirmIdentificationDocumentData;
